<template>
  <base-jin-nang-panel :title="tradeText">
    <template v-slot:bodyContent>
      <div class="sale-form">
        <div class="left">
          <div class="form-row mb30">
            <div class="row-label">股票名称:</div>
            <div class="row-input">
              <el-autocomplete
                v-model="state"
                placeholder=""
                :fetch-suggestions="fetchStock"
                @select="stockSelect"
                style="width:100%"
              >
              </el-autocomplete>
            </div>
          </div>
          <div class="form-row">
            <div class="row-label">{{ priceTips }}:</div>
            <div class="row-input">
              <el-input-number
                v-model="tradePrice"
                :step="0.01"
                style="width:305px"
                placeholder="请输入卖出价格"
              ></el-input-number>
            </div>
          </div>
          <div class="form-row">
            <div class="row-label"></div>
            <div class="row-input-wrapper">
              <div class="value-left">
                涨停<span class="c1 ml3">{{ limUpPriceStr }}</span>
              </div>
              <div class="value-right">
                跌停<span class="c3 ml3">{{ limDownPriceStr }}</span>
              </div>
            </div>
          </div>
          <div class="form-row mb11">
            <div class="row-label">{{ maxCountTips }}:</div>
            <div class="row-input page-c1">{{ maxCountStr }}股</div>
          </div>
          <div class="form-row">
            <div class="row-label">{{ countTips }}:</div>
            <div class="row-input">
              <el-input
                v-model="tradeCount"
                :placeholder="countPlaceHolderTips"
              ></el-input>
            </div>
          </div>
          <div class="form-row mb10">
            <div class="row-label"></div>
            <div class="row-input-wrapper">
              <div
                v-for="(item, index) of cwItems"
                :key="index"
                :class="{ 'value-opt': true, 'value-sel': index === cwIndex }"
                @click="onCWClick(item, index)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="form-row mb38">
            <div class="row-label">{{ tradeText }}金额:</div>
            <div class="row-input page-c1">
              {{ totalAmount }}
            </div>
          </div>
          <div class="form-row">
            <div class="row-label"></div>
            <div class="row-input page-c1">
              <el-button
                :class="{
                  buyBtn: true,
                  unactive: !isOrderActivity
                }"
                @click="secuEntrust"
                type="button"
                >{{ tradeText }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="right">
          <jin-nang-five-sale-and-buy
            :stockid="stockId"
            :lastclose="lastPrice"
            :isJJ="isJJ"
            @onUpdatePrice="onUpdatePrice"
            @onItemSlected="onbuySaleSlected"
            ref="fiveStall"
          ></jin-nang-five-sale-and-buy>
        </div>
      </div>
      <div class="repo-list">
        <jin-nang-repo-table
          :repoList="repolist"
          :is-row-pointer="true"
          v-on:repo-selected="OnRepoClick"
        ></jin-nang-repo-table>
      </div>
    </template>
  </base-jin-nang-panel>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel.vue'
import JinNangFiveSaleAndBuy from './JinNangFiveSaleAndBuy.vue'
import JinNangRepoTable from './JinNangRepoTable.vue'
import {
  getMaxPos,
  secuEntrust,
  getStock,
  getJinNangRepoList
} from '@/api/AuthorJinNang'
import StockUtils from '@/assets/js/stockUtils'
import { toThousands } from '@/assets/js/utils'
import { Loading } from 'element-ui'
import { search } from '@/api/stock'

export default {
  name: 'AuthorJinNangBuyOrSale',
  components: { JinNangFiveSaleAndBuy, BaseJinNangPanel, JinNangRepoTable },
  props: {
    isSell: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      state: '',
      name: '',
      price: 0,
      repolist: [],
      maxPosInfo: null, // 最大可买,价格和数量的变动单位等数据
      tradeCount: '',
      loadingText: '正在加载...',
      stock: null,

      cwItems: [
        { text: '全仓', value: 1 },
        { text: '1/2', value: 0.5 },
        { text: '1/3', value: 1 / 3.0 },
        { text: '1/4', value: 0.25 }
      ],
      cwIndex: -1,
      posArr: [],
      stockId: 0,
      sellPrice: 0,
      buyPrice: 0,
      tradePrice: 0
    }
  },
  mounted() {
    this.getJinNangRepoList()
    if (this.$route.query.stockId && this.$route.query.name) {
      this.stockId = Number(this.$route.query.stockId)
      this.state = this.$route.query.name + ' ' + this.$route.query.code
    }
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    },

    isJJ() {
      return this.stock
        ? StockUtils.isJJETFLOF(this.stock.exchange, this.stock.category)
        : false
    },

    lastPrice() {
      return this.stock ? this.stock.lastPrice : 0
    },
    stockCode() {
      return this.stock ? this.stock.code : '--'
    },

    stockName() {
      return this.stock ? this.stock.name : '--'
    },

    isOrderActivity() {
      return this.stockNameAndCode && this.tradePrice && this.tradeCount
    },

    limUpPriceStr() {
      if (this.limUpPrice && this.limUpPrice <= 0) {
        return '--'
      } else {
        return this.isJJ
          ? this.getPriceJJ(this.limUpPrice)
          : this.getPrice(this.limUpPrice)
      }
    },

    limDownPriceStr() {
      if (this.limDownPrice && this.limDownPrice <= 0) {
        return '--'
      } else {
        return this.isJJ
          ? this.getPriceJJ(this.limDownPrice)
          : this.getPrice(this.limDownPrice)
      }
    },

    inputStr() {
      if (this.stockNameAndCode) {
        return this.stockNameAndCode
      } else {
        return '股票名称/代码/拼音'
      }
    },

    maxCountTips() {
      if (this.isSell) {
        return '最大可卖'
      } else {
        return '最大可买'
      }
    },

    priceTips() {
      if (this.isSell) {
        return '卖出价格'
      } else {
        return '买入价格'
      }
    },
    pricePlaceHolderTips() {
      if (this.isSell) {
        return '请输入卖出价格'
      } else {
        return '请输入买入价格'
      }
    },
    countTips() {
      if (this.isSell) {
        return '卖出数量'
      } else {
        return '买入数量'
      }
    },

    countPlaceHolderTips() {
      if (this.isSell) {
        return '请输入卖出数量'
      } else {
        return '请输入买入数量'
      }
    },

    tradeText() {
      if (this.isSell) {
        return '卖出'
      } else {
        return '买入'
      }
    },

    maxCountValue() {
      if (this.maxPosInfo) {
        if (this.isSell) {
          return this.maxPosInfo.maxamts
        } else {
          return this.maxPosInfo.maxamtb
        }
      } else {
        return 0
      }
    },

    // 价格的变动幅度
    priceOffset() {
      if (this.maxPosInfo) {
        return this.maxPosInfo.pricelev / 1000
      } else {
        return this.isJJ ? 0.001 : 0.01
      }
    },

    // 数量的变动幅度
    countOffset() {
      if (this.maxPosInfo) {
        return this.maxPosInfo.boardlot
      } else {
        return 100
      }
    },

    maxCountStr() {
      if (this.maxPosInfo) {
        return this.maxCountValue
      } else {
        return '--'
      }
    },

    priceValue() {
      const price = parseInt(parseFloat(this.tradePrice) * 10000)
      return this.isJJ ? (price / 10000).toFixed(3) : (price / 10000).toFixed(2)
    },

    countValue() {
      return parseInt(this.tradeCount)
    },

    totalAmount() {
      if (this.priceValue && this.countValue) {
        const amount = this.isJJ
          ? (this.priceValue * this.countValue).toFixed(1)
          : parseInt(this.priceValue * this.countValue)
        return toThousands(amount)
      } else {
        return '--'
      }
    },
    stockNameAndCode() {
      return this.stock ? this.stock.name + ' ' + this.stock.code : ''
    },
    limUpPrice() {
      return this.stock ? this.stock.limUpPrice : 0
    },
    limDownPrice() {
      return this.stock ? this.stock.limDownPrice : 0
    }
  },
  watch: {
    stockId(newvalue, oldvalue) {
      this.cwIndex = -1
      if (newvalue === 0) {
        this.stock = null
        this.tradeCount = ''
      } else {
        this.getStockInfo()
      }
    },
    sellPrice() {
      if (this.isSell) {
        this.getMaxPosInfo()
      }
    },
    buyPrice() {
      if (!this.isSell) {
        this.getMaxPosInfo()
      }
    }
  },
  methods: {
    onPriceInputEvent() {
      this.getMaxPosInfo()
    },
    OnRepoClick(item) {
      this.state = item.tr.securitiesCode + ' ' + item.tr.securitiesName
      this.stockId = item.tr.stockId
      this.tradeCount = ''
      this.tradePrice = 0
    },
    async getMaxPosInfo() {
      if (!this.stockId) {
        return
      }
      if (!this.tradePrice) {
        return
      }
      const data = await getMaxPos({
        jinNangId: this.currentJinNangId,
        stockCode: this.stockId,
        price: parseInt(parseFloat(this.tradePrice) * 10000),
        priceType: 0
      })
      if (data && data.result.code === 0) {
        this.maxPosInfo = data.detail
      }
    },
    async getStockInfo() {
      if (this.stockId === 0) return
      const data = await getStock({
        goods_id: this.stockId
      })
      if (data && data.detail) {
        const detail = data.detail
        if (detail && detail.fieldValue) {
          const tempStock = {}
          tempStock.id = this.stockId
          tempStock.exchange = detail.exchange
          tempStock.category = parseInt(detail.category)
          tempStock.name = detail.fieldValue[0]
          tempStock.code = detail.fieldValue[1]
          tempStock.price = parseInt(detail.fieldValue[6])
          tempStock.lastPrice = parseInt(detail.fieldValue[106])
          tempStock.limUpPrice = parseInt(detail.fieldValue[1029])
          tempStock.limDownPrice = parseInt(detail.fieldValue[1030])

          this.stock = tempStock
        }
      }
    },
    secuEntrust() {
      if (!this.isOrderActivity) {
        return
      }
      const count = parseInt(this.tradeCount)
      if (count <= 0) {
        this.$message.error('请输入正确的数量')
        return
      }
      this.$confirm('确定提交' + this.tradeText + '委托?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.doOrder()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async doOrder() {
      const loadingInstance = Loading.service({ target: '.sale-form' })
      const that = this
      const data = await secuEntrust({
        jinNangId: this.currentJinNangId,
        stockCode: this.stockId,
        price: parseInt(parseFloat(this.tradePrice) * 10000),
        priceType: 0,
        amount: parseInt(this.tradeCount),
        bsFlag: this.isSell ? 'S' : 'B'
      })
      loadingInstance.close()
      if (data && data.result.code === 0) {
        this.$message({
          message: '委托下单成功',
          type: 'success'
        })

        that.stockId = 0
      } else {
        this.$message.error('委托下单失败,' + (data.result.msg || '未知错误'))
      }
    },
    async fetchStock(querystr, cb) {
      const data = await search({
        keyword: querystr
      })
      if (data && data.result.code === 0) {
        var response = data.detail
        cb(
          response.map(a => ({
            value: a.code + ' ' + a.name,
            data: a
          }))
        )
      }
    },
    async getJinNangRepoList() {
      const data = await getJinNangRepoList({
        jinNangId: this.currentJinNangId
      })
      if (data && data.result.code === 0) {
        this.repolist = data.detail.items
      }
    },
    onCWClick(item, index) {
      this.cwIndex = index
      if (item.value === 1) {
        this.tradeCount = this.maxCountValue + '' // 全部买卖时候 不用100的整数倍
      } else {
        this.tradeCount =
          parseInt((this.maxCountValue * item.value) / 100) * 100 + ''
      }
    },
    onUpdatePrice(priceBuy, priceSale) {
      this.sellPrice = priceSale || priceBuy
      this.buyPrice = priceBuy || priceSale
      if (this.isSell && this.tradePrice === 0) {
        this.tradePrice = this.isJJ
          ? (parseInt(this.sellPrice) / 10000).toFixed(3) + ''
          : (parseInt(this.sellPrice) / 10000).toFixed(2) + ''
      } else if (!this.isSell && this.tradePrice === 0) {
        this.tradePrice = this.isJJ
          ? (parseInt(this.buyPrice) / 10000).toFixed(3) + ''
          : (parseInt(this.buyPrice) / 10000).toFixed(2) + ''
      }
    },
    onbuySaleSlected(price) {
      this.tradePrice = this.isJJ
        ? (parseInt(price) / 10000).toFixed(3) + ''
        : (parseInt(price) / 10000).toFixed(2) + ''
    },
    stockSelect(item) {
      this.stockId = item.data.id
      this.tradeCount = ''
      this.tradePrice = 0
    },

    getPrice(val) {
      return (val / 10000).toFixed(2)
    },

    getPriceJJ(val) {
      return (val / 10000).toFixed(3)
    }
  }
}
</script>

<style scoped>
.sale-form {
  display: flex;
  justify-content: space-between;
}
.left {
  flex: auto;
}
.right {
  margin-left: 75px;
}
.form-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.row-label {
  text-align: center;
  line-height: 44px;
  letter-spacing: 0px;
  color: #858585;
  margin-right: 20px;
  width: 60px;
}
.row-input {
  flex: auto;
}
.row-input-wrapper {
  flex: auto;
  display: flex;
  justify-content: space-between;
  margin: 8px 0px;
}

.value-left,
.value-right {
  font-family: MicrosoftYaHei;
  color: #858585;
}

.value-opt {
  width: 61px;
  height: 24px;
  border-radius: 5px;
  border: solid 1px #ebebeb;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  color: #858585;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
}

.value-sel {
  color: #046bcc;
  border-color: #046bcc;
}

.mb30 {
  margin-bottom: 30px;
}

.mb38 {
  margin-bottom: 38px;
}

.page-c1 {
  color: #262626;
}

.buyBtn {
  width: 180px;
  height: 44px;
  background-color: #046bcc;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}

.repo-list {
  margin-top: 50px;
}

.unactive {
  opacity: 0.5;
  cursor: auto;
}

.ml3 {
  margin-left: 3px;
}

.mb11 {
  margin-bottom: 11px;
}

.mb10px {
  margin-bottom: 10px;
}
</style>
